
export const updateUserInfo = (userInfo = {}) => {
  if (!window || !window.zE) return;

  const conversationFields = Object.keys(userInfo)?.map((uInfo) => {
    return {
      id: uInfo,
      value: userInfo[uInfo]
    };
  });

  window?.zE('messenger:set', 'conversationFields', [
    conversationFields
  ]);
};

export const updateLocale = (locale) => {
  if (!window || !window.zE) return;

  window?.zE('messenger:set', 'locale', locale);
};

export const bootZendesk = () => {
  if (!window || !window.zE) return;

  window?.zE('messenger:on', 'close', function () {
    //window?.zE('messenger', 'hide');
  });
};

export const shutdownSupportChat = () => {
  if (!window || !window.zE) return;

  //window?.zE('messenger', 'hide');
};

const openSupportChat = () => {
  if (!window || !window.zE) return;

  window?.zE('messenger', 'open');
};

const closeSupportChat = () => {
  if (!window || !window.zE) return;

  window?.zE('messenger', 'close');
};

const loginUser = (callback) => {
  if (!window || !window.zE) return;

  window?.zE('messenger', 'loginUser', callback);
};

const logOutUser = () => {
  if (!window || !window.zE) return;
  window?.zE('messenger', 'logoutUser');
};


const LiveAgent = {
  openSupportChat,
  closeSupportChat,
  shutdownSupportChat,
  updateUserInfo,
  loginUser,
  logOutUser
};
export default LiveAgent;